import { render, staticRenderFns } from "./IndexDocumentationComponent.vue?vue&type=template&id=1cdd34e2&"
import script from "./IndexDocumentationComponent.vue?vue&type=script&lang=js&"
export * from "./IndexDocumentationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports